import { createSlice } from "@reduxjs/toolkit";

const menuSlice = createSlice({
  name: "menu",
  initialState: {
    isShowMenuModule: false,
    isShowMenuProcess: false,
    moduleSelected: "",
    procesSelected: "",
    showModalReplace: false,
    showModalDevices: false,
  },
  reducers: {
    showMenuModule: (state, action) => {
      if (action.payload !== "outside") {
        state.isShowMenuModule = state.isShowMenuModule ? false : true;
      } else {
        state.isShowMenuModule = false;
      }
    },
    reset: (state) => {
      state.isShowMenuModule = false;
      state.isShowMenuProcess = false;
      state.moduleSelected = "";
      state.procesSelected = "";
    },
    setModuleSelected: (state, action) => {
      state.moduleSelected = action.payload;
    },
    setProcesSelected: (state, action) => {
      state.procesSelected = action.payload;
    },
    setShowMenuModule: (state) => {
      state.isShowMenuModule = !state.isShowMenuModule;
    },
    setShowMenuProcess: (state, action) => {
      state.isShowMenuProcess = action.payload;
    },
    setShowModalReplace: (state) => {
      state.showModalReplace = !state.showModalReplace;
    },
    setShowModalDevices: (state) => {
      state.showModalDevices = !state.showModalDevices;
    },
  },
});

export const {
  showMenuModule,
  reset,
  setModuleSelected,
  setProcesSelected,
  setShowMenuModule,
  setShowMenuProcess,
  setShowModalReplace,
  setShowModalDevices,
} = menuSlice.actions;
export default menuSlice.reducer;

export const getisShowMenuModule = (state) => {
  return state.menu.isShowMenuModule;
};
export const getModuleSelected = (state) => {
  return state.menu.moduleSelected;
};
export const getProcesSelected = (state) => {
  return state.menu.procesSelected;
};
export const getShowMenuProcess = (state) => {
  return state.menu.isShowMenuProcess;
};

export const getOptionsMenu = (state) => {
  // Contexto embebido (Mi Puesto): las opciones se resuelven contra el
  // proceso REAL de la pantalla montada, no contra el proceso anfitrion
  const override = state.tracking?.contextOverride;
  const iModulo = override?.MODIDXXX ?? state.menu.moduleSelected.MODIDXXX;
  const iProceso = override?.PROIDXXX ?? state.menu.procesSelected.PROIDXXX;
  const moduleSelected = state.persistedReducer.menuUser.filter((CIMS0003) => {
    return CIMS0003.MODIDXXX === iModulo;
  });
  const processes = moduleSelected[0]?.CIMS0004 ?? [];
  const processSelected = processes.filter((CIMS0004) => {
    return CIMS0004.PROIDXXX === iProceso;
  });
  return processSelected[0]?.CIMS0005 ?? [];
};

export const getOptionsMenubyType = (optionsMenu, typeOption) => {
  let optionsMenuFilter = optionsMenu.filter((opt) => {
    return opt.TIPMENUX === typeOption;
  });
  return optionsMenuFilter;
};

export const getShowModalReplace = (state) => {
  return state.menu.showModalReplace;
};

export const getShowModalDevices = (state) => {
  return state.menu.showModalDevices;
};
